import React, { useState } from 'react';
import PropTypes from 'prop-types';

import SelectionExpandable from './SelectionExpandable';
import { useAppSelector } from '../hooks';
import { getClassNames } from '../../../utils';

const BottomBar = ({ checkoutUrl }: BottomBarProps) => {
  const { upsellMessages, minimumPerformances } = useAppSelector((state) => state.sessionSlice);
  const performances = useAppSelector((state) => state.packageDataSlice) as PerformanceInPackage[];

  const [nextWasPressed, setNextWasPressed] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [focusedIndex, setFocusedIndex] = useState(null);

  if (!performances) return <></>;

  if (!performances || performances.length === 0) {
    document.body.classList.remove('chat-button-margin');

    return <></>;
  }

  const groupedPerformances: PerformanceInPackage[][] = Object.values(performances.reduce((acc, cur, i) => {
    const currentGroup = Math.ceil(
      Math.ceil(performances.length / 5) - (((Math.ceil(performances.length / 5) * 5) - i - 1) / 5),
    );

    if (!acc[currentGroup]) acc[currentGroup] = [];
    acc[currentGroup].push(cur);

    return acc;
  }, {}));

  document.body.classList.add('chat-button-margin');

  const handleNextClick = (e) => {
    e.preventDefault();
    setNextWasPressed(true);
    // Call the endpoint to extend cart session
    fetch('/actions/ssoapi/api/extend-cart-session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // After successful response, redirect to checkout URL
        window.location.href = checkoutUrl;
      })
      .catch((error) => {
        console.error('Error extending cart session:', error);
        // Continue with redirect even if there's an error
        window.location.href = checkoutUrl;
      });
  };

  return (
    <div className="c-cyop__bottom-bar">
      <SelectionExpandable
        isExpanded={isExpanded}
        performances={performances}
        setFocusedIndex={setFocusedIndex}
        setIsExpanded={setIsExpanded}
      />

      <div className="c-cyop__bottom-bar-content-wrapper">
        <div className="c-cyop__bottom-bar-content">
          {groupedPerformances.map((performanceGroup, groupIndex) => (
            <div
              className={getClassNames(null, 'c-cyop__bottom-bar-images', {
                'c-cyop__bottom-bar-images--expanded': isExpanded && groupedPerformances.length === 1,
              })}
              key={performanceGroup[0].title}
            >
              {performanceGroup.map((performance, performanceIndex) => (
                <div
                  className={getClassNames(null, 'c-cyop__bottom-bar-image-wrapper', {
                    'c-cyop__bottom-bar-image-wrapper--focused': focusedIndex === (groupIndex * 5) + performanceIndex,
                  })}
                  key={performance.title}
                  style={{ marginTop: `${(15 / performanceGroup.length) * performanceIndex}px` }}
                >
                  <div className="c-cyop__bottom-bar-image" style={{ backgroundImage: `url(${performance.image})` }} />
                </div>
              ))}
            </div>
          ))}

          <strong className="c-cyop__bottom-bar-highlighted-text">
            {performances.length}
            &nbsp;selected
          </strong>

          {upsellMessages && `- ${upsellMessages}`}
        </div>
      </div>

      <div className={getClassNames(null, 'c-cyop__bottom-bar-button-wrapper', {
        'c-cyop__bottom-bar-button-wrapper--disabled': performances.length < minimumPerformances || nextWasPressed,
      })}
      >
        <a
          href={checkoutUrl}
          onClick={handleNextClick}
        >
          Next
        </a>
      </div>
    </div>
  );
};

const bottomBarPropTypes = {
  checkoutUrl: PropTypes.string.isRequired,
};

BottomBar.propTypes = bottomBarPropTypes;

type BottomBarProps = PropTypes.InferProps<typeof bottomBarPropTypes>;

export default BottomBar;
